import { css } from 'emotion';
import {
	museo900,
	pink,
	tabletPortraitMinWidthBreakpoint,
	mobileMaxWidthBreakpoint,
	mobileMinWidthBreakpoint,
} from 'inside-out/global-styles';

export const buttonStyle = (color = pink) =>
	css({
		...museo900,
		background: color,
		textTransform: 'uppercase',
		color: '#fff',
		lineHeight: '1.2',
		fontWeight: 'normal',
		padding: '0 40px 0 20px',
		textDecoration: 'none',
		borderRadius: '8px',
		position: 'relative',
		boxShadow: 'rgba(0,0,0,0.18) 0 6px 12px',
		display: 'flex',
		alignItems: 'center',

		[`@media (min-width: ${mobileMinWidthBreakpoint}px)`]: {
			fontSize: '12px',
			minHeight: '36px',
		},

		[`@media (min-width: ${mobileMaxWidthBreakpoint}px)`]: {
			fontSize: '18px',
			minHeight: '50px',
		},

		[`@media (min-width: ${tabletPortraitMinWidthBreakpoint}px)`]: {
			fontSize: '26px',
			minHeight: '64px',
		},
	});

export const buttonTextStyle = css({
	[`@media (min-width: ${mobileMinWidthBreakpoint}px)`]: {
		paddingTop: '2px',
	},
	[`@media (min-width: ${mobileMaxWidthBreakpoint}px)`]: {
		paddingTop: '4px',
	},
	[`@media (min-width: ${tabletPortraitMinWidthBreakpoint}px)`]: {
		paddingTop: '4px',
	},
})

export const arrowIconStyle = css({
	fontSize: 0,
	position: 'absolute',
	top: '50%',
	transform: 'translateY(-50%)',
	right: '16px',
});

export const iconStyle = css({
	marginRight: '16px'
});



// WEBPACK FOOTER //
// ./src/components/shared/fullWidthCTA/styles.js